import { cn } from 'src/utils/shadcn';

interface SectionBlockProps extends React.HTMLAttributes<HTMLDivElement> {}
const SectionBlock = ({ className, children, ...props }: SectionBlockProps) => {
    return (
        <section className={cn('relative flex w-full flex-col gap-4 sm:gap-6', className)} {...props}>
            {children}
        </section>
    );
};

interface SectionBlockHeaderProps extends React.HTMLAttributes<HTMLDivElement> {}
function SectionBlockHeader({ className, children, ...props }: SectionBlockHeaderProps) {
    return (
        <div className={cn('flex w-full flex-wrap items-end justify-between gap-2', className)} {...props}>
            {children}
        </div>
    );
}

interface SectionBlockHeadProps extends React.HTMLAttributes<HTMLDivElement> {}
function SectionBlockHead({ className, children, ...props }: SectionBlockHeadProps) {
    return (
        <div className={cn('flex flex-1 flex-col place-self-center', className)} {...props}>
            {children}
        </div>
    );
}

interface SectionBlockTitleProps extends React.HTMLAttributes<HTMLHeadingElement> {}
function SectionBlockTitle({ className, children, ...props }: SectionBlockTitleProps) {
    return (
        <h3 className={cn('text-lg font-semibold', className)} {...props}>
            {children}
        </h3>
    );
}

interface SectionBlockSubtitleProps extends React.HTMLAttributes<HTMLHeadingElement> {}
function SectionBlockSubtitle({ className, children, ...props }: SectionBlockSubtitleProps) {
    return (
        <p className={cn('max-w-sm text-sm text-gray-500', className)} {...props}>
            {children}
        </p>
    );
}

interface SectionBlockSeparatorProps extends React.HTMLAttributes<HTMLHRElement> {}
function SectionBlockSeparator({ className, ...props }: SectionBlockSeparatorProps) {
    return <hr className={cn('-mt-1 h-px bg-gray-200', className)} {...props} />;
}

interface SectionBlockBodyProps extends React.HTMLAttributes<HTMLDivElement> {}
function SectionBlockBody({ className, children, ...props }: SectionBlockBodyProps) {
    return (
        <div className={cn('flex gap-4 sm:gap-6', className)} {...props}>
            {children}
        </div>
    );
}

export {
    SectionBlock,
    SectionBlockHeader,
    SectionBlockHead,
    SectionBlockTitle,
    SectionBlockSubtitle,
    SectionBlockSeparator,
    SectionBlockBody,
};
